<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform" xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <div class="layout-product-viewer360">
    <div v-if="view" class="container">
      <vue-three-sixty
          :amount=Number(amount)
          :imagePath="path"
          fileName="image-{index}.jpg"
          spinReverse
          autoplay
          buttonClass="dark"
          scrollImage
      >
  <!--      <template v-slot:header>
          <div class="v360-header text-light bg-dark">
            <span class="v360-header-title">36 Images - Autoplay (1 loop) - Reverse Spin</span>
            <span class="v360-header-description"></span>
          </div>
        </template>-->
      </vue-three-sixty>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'vue-three-sixty': () => import('@/components/I360Viewer'),
  },
  props: {
    path: "",
    amount: 0,
    view: false
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  mounted() {
    this.disableZoomin();
  },
  methods: {
    handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
    },
    disableZoomin(){
      document.addEventListener("gesturestart", function (e) {
        e.preventDefault();
        document.body.style.zoom = 0.99;
      });
      document.addEventListener("gesturechange", function (e) {
        e.preventDefault();
        document.body.style.zoom = 0.99;
      });

      document.addEventListener("gestureend", function (e) {
        e.preventDefault();
        document.body.style.zoom = 1;
      });
    }
  },
  created() {

    let viewer360css = document.createElement('link');
    viewer360css.setAttribute("type","text/css");
    viewer360css.setAttribute("rel","stylesheet");
    viewer360css.setAttribute('href', '//cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css')
    document.head.appendChild(viewer360css)

      window.addEventListener('resize', this.handleResize);
      this.handleResize();
  },
  destroyed() {
      window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="scss" scoped>
.layout-product-viewer360 {
  position: relative;
}
</style>